import { FooterLogo } from 'types/models/FooterLogo';
import { footerRoute } from 'apiRoutes/footer';
import useFetch from 'hooks/useFetch';

import Footer from './Footer';

type Props = {
  footerLogos?: FooterLogo[];
};

const FooterContainer = ({ footerLogos }: Props): JSX.Element => {
  const [, { data }] = useFetch(footerRoute, { payload: { withLogos: !footerLogos }, manual: false });

  return (
    <Footer
      menuItems={data?.footerMenu || []}
      rewards={data?.rewards || []}
      brands={data?.brands || []}
      logos={footerLogos || data?.footerLogos || []}
      apiVersion={data?.apiVersion.version || ''}
    />
  );
};

export default FooterContainer;
